// Age category buckets used by the Membership > Family Dynamic section.
// Subcategories are quoted from the spec exactly so the analytics list
// stays consistent with the church ministry naming.

export const AGE_GROUPS = [
  {
    id: "childrens",
    label: "Children's Ministries",
    range: "0–11",
    subs: [
      { id: "infants",       label: "Infants",          range: "0–12 months", min: 0,     max: 0.999, isMonthRange: true, minMonth: 0,  maxMonth: 12 },
      { id: "toddlers",      label: "Toddlers",         range: "1–2",         min: 1,     max: 2.999 },
      { id: "preschool",     label: "Preschool",        range: "3–5",         min: 3,     max: 5.999 },
      { id: "early_elem",    label: "Early Elementary", range: "6–8",         min: 6,     max: 8.999 },
      { id: "preteens",      label: "Preteens",         range: "9–11",        min: 9,     max: 11.999 },
    ],
  },
  {
    id: "youth",
    label: "Youth Ministry",
    range: "12–18",
    subs: [
      { id: "middle_school", label: "Middle School",   range: "12–14", min: 12, max: 13.999 },
      { id: "high_school",   label: "High School",     range: "14–18", min: 14, max: 18.999 },
    ],
  },
  {
    id: "young_adults",
    label: "Young Adults",
    range: "18–35",
    subs: [
      { id: "college",        label: "College",              range: "18–22", min: 18, max: 22.999 },
      { id: "young_pros",     label: "Young Professionals",  range: "23–30", min: 23, max: 30.999 },
      { id: "young_families", label: "Young Families",       range: "31–35", min: 31, max: 35.999 },
    ],
  },
  {
    id: "adult",
    label: "Adult Ministry",
    range: "36–64",
    subs: [
      { id: "median_adults", label: "Median Adults", range: "36–49", min: 36, max: 49.999 },
      { id: "empty_nesters", label: "Empty Nesters", range: "50–64", min: 50, max: 64.999 },
    ],
  },
  {
    id: "senior",
    label: "Senior Adult Ministry",
    range: "65+",
    subs: [
      { id: "young_seniors",  label: "Young Seniors",  range: "65–74", min: 65, max: 74.999 },
      { id: "golden_seniors", label: "Golden Seniors", range: "75–84", min: 75, max: 84.999 },
      { id: "elder_seniors",  label: "Elder Seniors",  range: "85+",   min: 85, max: 200 },
    ],
  },
];

// Years (with months fraction) since dob — null if no dob.
// `dob` may be a YYYY-MM-DD string; parse it as a LOCAL date to avoid the
// UTC midnight shift that drops the day by one in negative-UTC timezones.
function _parseDobLocal(dob) {
  if (!dob) return null;
  const s = String(dob);
  const mm = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (mm) return new Date(Number(mm[1]), Number(mm[2]) - 1, Number(mm[3]));
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}
export function ageInYears(dob) {
  if (!dob) return null;
  const d = _parseDobLocal(dob);
  if (!d || isNaN(d.getTime())) return null;
  const now = new Date();
  let years = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  const dayDelta = now.getDate() - d.getDate();
  if (m < 0 || (m === 0 && dayDelta < 0)) years -= 1;
  // approximate fractional years for sub-12-month bucket support
  const ms = now - d;
  return ms < 0 ? null : Math.max(0, ms / (365.25 * 24 * 3600 * 1000));
}

export function matchesAgeSub(member, sub) {
  const age = ageInYears(member.dob);
  if (age === null) return false;
  if (sub.isMonthRange) {
    const months = age * 12;
    return months >= sub.minMonth && months <= sub.maxMonth;
  }
  return age >= sub.min && age <= sub.max;
}

export function bucketMembersByAge(members) {
  const buckets = {};
  AGE_GROUPS.forEach(g => g.subs.forEach(s => { buckets[s.id] = []; }));
  members.forEach(m => {
    AGE_GROUPS.forEach(g => g.subs.forEach(s => {
      if (matchesAgeSub(m, s)) buckets[s.id].push(m);
    }));
  });
  return buckets;
}
